module.exports = __webpack_public_path__ + "img/kinside-logo.cf1e5cd9.svg";